/* "Completa il tuo look": il prodotto suggerito arriva dai Complementary
   products di Search & Discovery.

   I complementari non sono leggibili dal Liquid normale: vivono solo
   nell'oggetto recommendations, che Shopify popola quando una sezione viene
   richiesta sulla rotta /recommendations/products con product_id e
   intent=complementary. Quindi si chiede quella rotta una volta per ogni
   prodotto distinto nel carrello: ogni risposta e' gia' il blocco renderizzato
   col miglior candidato di quel prodotto, e qui si tiene quello col
   data-look-price piu' alto. Regola concordata: vince il piu' costoso. */
if ( typeof customElements.get('complete-look') == 'undefined' ) {

	const MAX_ARTICOLI = 6; // oltre non vale la pena: una richiesta per articolo

	class CompleteLook extends HTMLElement {

		connectedCallback(){
			if ( this._listening ) return;
			this._listening = true;
			this._refresh = ()=>this.scheduleRefresh();
			document.addEventListener('krown:cart:add', this._refresh);
			document.addEventListener('krown:cart:update', this._refresh);
			// Il render lato server non ha l'oggetto recommendations, quindi al
			// primo caricamento il blocco e' vuoto e va riempito subito.
			this.scheduleRefresh();
		}

		disconnectedCallback(){
			document.removeEventListener('krown:cart:add', this._refresh);
			document.removeEventListener('krown:cart:update', this._refresh);
			this._listening = false;
		}

		// Togliere una riga dal carrello puo far partire piu eventi di fila: una
		// sola tornata di richieste per giro di eventi basta.
		scheduleRefresh(){
			clearTimeout(this._timer);
			this._timer = setTimeout(()=>this.refresh(), 60);
		}

		get root(){
			return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
		}

		async refresh(){
			const section = this.dataset.section;
			if ( ! section ) return;

			// Una richiesta in corso viene abbandonata se ne parte un'altra.
			const giro = (this._giro = (this._giro || 0) + 1);

			try {
				const cart = await fetch(`${this.root}cart.js`).then(r=>r.json());
				const ids = [...new Set((cart.items || []).map(i=>i.product_id))].slice(0, MAX_ARTICOLI);
				if ( giro !== this._giro ) return;
				if ( ! ids.length ) { this.innerHTML = ''; return; }

				const blocchi = await Promise.all(ids.map(id =>
					fetch(`${this.root}recommendations/products?section_id=${section}&product_id=${id}&intent=complementary&limit=10`)
						.then(r=>r.text())
						.then(t=>new DOMParser().parseFromString(t, 'text/html').querySelector('[data-js-cart-look-section]'))
						.catch(()=>null)
				));
				if ( giro !== this._giro ) return;

				let migliore = null, prezzo = -1;
				blocchi.forEach(blocco => {
					if ( ! blocco ) return;
					const contenuto = blocco.querySelector('[data-look-price]');
					if ( ! contenuto ) return;
					const valore = parseInt(contenuto.dataset.lookPrice || '0', 10);
					if ( valore > prezzo ) { prezzo = valore; migliore = blocco; }
				});

				this.innerHTML = migliore ? migliore.innerHTML : '';
				if ( this.innerHTML ) window.KrownAssetLoader?.loadScriptsIn(this);
			} catch (error) {
				console.warn('complete-look', error);
			}
		}
	}

	customElements.define('complete-look', CompleteLook);
}
